import React from 'react';
import ProfileGenerique from '../profile/ProfileGenerique';

export default function ProfileIntendant() {
    return <ProfileGenerique role="intendant" title="🏪 Mon profil intendant" color="from-amber-600 to-orange-600" />;
}